const Getters = {
  getStockAdjustListFromState: (state) => {
    return state.stockAdjustList
  }
}

export default Getters
